<template>
  <div class="big_box" style="background-color: #fff">

        <div class="nav">
<!--          <div class="btn" @click="bk()">< 返回</div>-->
<!--          <span class="el-dropdown-link c1">-->
<!--             订单查询<i class="el-icon-arrow-down el-icon&#45;&#45;right c2"></i>-->
<!--          </span>-->
<!--          <p class="c3">王晓云</p>-->

          <div style="width: 100%;height: 50px;background-color: #fff;line-height: 50px;text-align: center;">
            <div style="color: #4D586D;position: relative">订单查询<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
              <div class="grid-content bg-purple " style="position: absolute;left: 10px;top: 0px;color: #FF9901">
                <span class="el-icon-arrow-left" @click="bk()">返回</span>
              </div>
            </div>
            <span style="position: relative;top:-31px;font-size: 13px;color: #B0B5B9;"> 王晓燕</span>
          </div>
        </div>

        <div class="cenBox" style="padding: 10px;display: flex;justify-content: space-between;align-items: center">
          <el-date-picker
              v-model="start_time"
              type="date"
              placeholder="开始日期"
              prefix-icon="cc"
              size="mini"
              style="width: 87px;"
              value-format="yyyy-MM-dd">
          </el-date-picker>
          <span>-</span>
          <el-date-picker
              v-model="end_time"
              type="date"
              size="mini"
              placeholder="结束日期"
              prefix-icon=" "
              style="width: 87px"
              value-format="yyyy-MM-dd">
          </el-date-picker>
          <span style="font-size: 14px">下单方式</span>
          <el-select  size="mini" v-model="order_form" placeholder="请选择" style="width: 100px">
            <el-option
                v-for="item in op"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
            </el-option>
          </el-select>
        </div>
        <div class="cenBox1"  style="padding:0px 10px 10px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #e8e8e8">
          <el-input  size="mini" v-model="searchStr" placeholder="输入点单编码或客户名称" class="inputSty" style="width: 80%;">
          </el-input>
          <span>
            <button @click="dats()" size="mine" style="border-radius: 4px;">查询</button>
          </span>
        </div>
        <div  class="cenBox2"  style="padding: 0 10px">
          <div v-for="item in lists" style="border-bottom: 1px solid #e8e8e8">
            <el-row :gutter="20">
              <el-col :span="2"><div class="grid-content bg-purple">
                <p style="margin-top: 10px"><img src="./../../assets/images/img1.png" class="ig"></p>
              </div></el-col>
              <el-col :span="17"><div class="grid-content bg-purple">
                <p class="a1">订单号：{{item.order_code}}</p>
                <p class="a2">买家机构：{{item.institution_name}}</p>
                <p class="a2">金额：{{item.amount}}</p>
              </div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple">
                <p class="a4">{{item.status}}</p>
                <p class="el-icon-arrow-right a3" @click="details()"></p>
              </div></el-col>
            </el-row>

          </div>
        </div>
  </div>
</template>

<script>
import http from "../../APIService/http";

export default {
  name: "login6",
  data(){
    return{
      start_time:'',
      end_time:'',
      searchStr:'',
      lists:[],
      tenant_id:1472813523,
      offset:0,
      order_form:'',
    }
  },
  methods:{
    bk(){
      this.$router.push({path:"/reportIndex"})
    },
    details(){

    },
    dats(){
      let that=this
      let forms = {
        searchStr:this.searchStr,
        tenant_id:this.tenant_id,
        offset:this.offset,
        start_time:this.start_time,
        end_time:this.end_time,
        order_form:this.order_form
      }
      http.post('/wapi/gkGetFeedback/GkOrderQuery',forms)
          .then(function (res) {
            that.lists = res.data.data
            console.log(that.lists)
          })
    }
  },
  created() {
    this.dats()
  }
}
</script>

<style lang="css" >
    .inputSty /deep/ span.el-input__prefix{
        left: 110px;

    }
    .inputSty /deep/ .el-input__inner{
        background: #f3f0f0;
        color: black;
        text-align: center;
    }
  .a1{
    font-size: 15px;
  }
  .a2,.a3{
    color: #b5babf;
    font-size: 13px;
  }
  .a3{
    float: right;
    margin-top: 5px;
    margin-right: 5px;
  }
  .a4{
    font-size: 13px;
    color: #b5babf;
  }
  .a2{
    margin-top: -5px;
  }
  .a1,.a2{
    padding-left: 10px;
  }
  .ig{
    width: 27px;
    height: 27px;
  }
  .el-card__body {
    padding: 5px;
  }
  .btn{
    color: orange;
    margin-top: 15px;
    padding-left: 5px;
  }
  button{
    background-color: #FF9901;
    color: white;
    border: none;
  }
  .nav{
    width: 100%;
    height: 50px;
    background-color: white;
  }
  .c1{
    margin-left: 130px;
    margin-top: -15px;
    position: absolute;
    font-size: 18px;
  }
  .c2{
    color: #b9afaf;
    margin-left: 3px;
    position: absolute;
  }
  .c3{
    color:  #b9afaf;
    font-size: 13px;
    position: absolute;
    margin-top: 5px;
    margin-left: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/gkReport/OrderQuery.vue